import React from 'react';
import {
  Autocomplete,
  TextField,
  IconButton,
  CircularProgress
} from '@mui/material';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import { translateText } from '../service/deepl/DeeplService';
import StrapiService from "../strapi/StrapiService";

const getOppositeLang = (lang) => (lang === 'de' ? 'en' : 'de');

const TranslatableAutocomplete = ({
                                    label,
                                    lang,
                                    value = [],
                                    otherLangValue = [],
                                    onChange,
                                    options = [],
                                    tagName,
                                    sx,
                                  }) => {
  const [loading, setLoading] = React.useState(false);

  const shouldShowTranslate =
    (!value || value.length === 0) && otherLangValue && otherLangValue.length > 0;

  const handleTranslate = async () => {
    try {
      setLoading(true);

      const textsToTranslate = otherLangValue.map((item) =>
        typeof item === 'string' ? item : item.title
      );

      const translatedTexts = await Promise.all(
        textsToTranslate.map((text) =>
          translateText(text, lang, getOppositeLang(lang))
        )
      );

      const resolvedValues = await Promise.all(
        translatedTexts.map(async (translated) => {
          try {
            const results = await StrapiService.getTags(tagName, translated, lang);
            if (Array.isArray(results) && results.length > 0) {
              const match = {
                title: results[0].Name,
                id: results[0].id,
                documentId: results[0].documentId,
              };
              // console.log('MATCH:', match);
              return match;
            } else {
              return translated;
            }
          } catch (e) {
            console.error('Error fetching tag for', translated, e);
            return translated;
          }
        })
      );

      // console.log("New Value: " + JSON.stringify(resolvedValues))
      onChange(resolvedValues);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Autocomplete
      multiple
      freeSolo
      options={options}
      value={value}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : option.title
      }
      onChange={(e, val) => onChange(val)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="normal"
          sx={sx}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {shouldShowTranslate && !loading && (
                  <IconButton size="small" onClick={handleTranslate}>
                    <GTranslateIcon fontSize="small" />
                  </IconButton>
                )}
                {loading && <CircularProgress size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      fullWidth
    />
  );
};

export default TranslatableAutocomplete;
